module.exports = __webpack_public_path__ + "static/media/TranscendLife1.5cc46697.jpg";